import React, { useEffect, useState } from "react"
import dateUtil from "../../ts/util/dateUtil"
import TextInput from "./TextInput"
import WarekiPicker from "./WarekiPicker"
import * as wjCore from "@grapecity/wijmo"

const WarekiInput: React.FC<{
  name: string
  value: string | null | undefined
  setValue: (value: string | null | undefined) => unknown
  isInvalidValue?: boolean
  isRequired?: boolean
  isReadOnly?: boolean
  warekiPickerOuterStyle?: React.CSSProperties
}> = (props) => {
  const [formattedValue, setFormattedValue] = useState("")

  useEffect(() => {
    if (wjCore.isNullOrWhiteSpace(props.value ?? "")) {
      setFormattedValue("")
    } else {
      setFormattedValue(dateUtil.show和暦含Format(props.value))
    }
  }, [props.value])

  return (
    <div className={props.isRequired ? "d-flex  required_input" : "d-flex"}>
      <TextInput
        id={props.name}
        name={props.name}
        onFocus={(e) => {
          setFormattedValue(dateUtil.format(props.value, "YYYYMMDD"))
        }}
        onBlur={(e) => {
          // wijmoのwijmo.Globalize.parseDate(value, format)を利用して許容された形式で入力された文字列をISOStringに変換する
          const value = dateUtil.toISoDateStringBy和暦含Format(e.target.value)
          props.setValue(value)
          setFormattedValue(dateUtil.show和暦含Format(props.value))
        }}
        value={formattedValue}
        setValue={setFormattedValue}
        maxLength={100}
        className={props.isInvalidValue ? "is-error" : ""}
        isReadOnly={props.isReadOnly}
      />{" "}
      <WarekiPicker
        isReadOnly={props.isReadOnly}
        value={props.value}
        setValue={(v) => {
          props.setValue(v)
          setFormattedValue(dateUtil.show和暦含Format(v))
        }}
        outerStyle={props.warekiPickerOuterStyle}></WarekiPicker>
    </div>
  )
}

export default WarekiInput
